<template>
  <div class="page5 content" style="width:100%;">
      <el-row style="height: 4vh; padding-left: 0.5vw; padding-top: 0.1vh;margin-bottom: 1vh;">
       <el-col :span="24" style="margin:0;">
        <div class="grid-content1 bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>绿色施工</el-breadcrumb-item>
            <el-breadcrumb-item>数据统计</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div class="main">
      <!-- 警报开始 -->
      <div class="alarm">
        <span class="red-circle"></span>
        <!-- <div style="color: #333">警报·东侧大门扬尘超标</div> -->
        <template v-if="earlyWarnData.length != 0">
          <div style="color: #ff0000" v-for="(item, index) in earlyWarnData" :key="index">
            <span style="margin-right: 15px;">{{item}}</span>
          </div>
        </template>
        <span v-else style="color: #333;">暂无警报</span>
      </div>
      <!-- 警报结束 -->
      <!-- 扬尘监测开始 -->
      <div class="dust">
        <div class="title">扬尘监测</div>
        <div class="dust-content">
          <div class="dust-left">
            <div class="weather-date">
              <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">实时天气</p></div>
              <div>{{time}}</div>
            </div>
            <div class="weather">
                <img :src="weather.now1" style="width: 8vw;"/>
            </div>
            <div class="temperature">
              <p style="font-size: 1.2vw;">{{weather.now3}}</p>
              <p style="font-size: 1.2vw;">{{weather.now2}}</p>
            </div>
          </div>
          <div class="dust-center">
             <div style="display: flex;justify-content: space-between;">
               <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">实时数据</p></div>
               <div style="color: #0b62f0;font-size: 0.9vw;">3分钟前更新</div>
             </div>
              <div ref="chart1" style="width: 90%;height: 35vh;margin-top: -5vh;"></div>
          </div>
          <div class="dust-right">
             <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">警报详情</p></div>
             <div class="detail">
               <!-- <div class="detail-item"><span class="red-circle"></span><p style="font-size: 0.9vw;color: #ff0000">PM2.5超标，数值86μg/m³</p></div> -->
                 <template v-if="earlyWarnDataDetail.length != 0">
                    <div v-for="(item, index) in earlyWarnDataDetail" :key="index">
                        <p class="detail-item" style="font-size: 0.9vw;color: #ff0000;">{{item}}</p>
                    </div>
                 </template>
                 <p v-else style="font-size: 0.9vw;">暂无警报</p>
               </div>
          </div>
        </div>
      </div>
      <!-- 扬尘监测结束 -->
      <!-- 污水检测开始 -->
      <div class="sewage">
        <div class="title">污水监测</div>
        <div class="sewage-content">
          <div class="sewage-left">
            <div style="display: flex;justify-content: space-between;">
               <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">实时数据</p></div>
               <div style="color: #0b62f0;font-size: 0.9vw;">3分钟前更新</div>
            </div>
             <div ref="chart2" style="width: 97%;height: calc(100% - 4vh);"></div>
          </div>
          <div class="sewage-center">
            <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">周数据</p></div>
            <div ref="chart3" style="width: 90%;height: calc(100% - 4vh);"></div>
          </div>
          <div class="sewage-right">
            <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">实时预警</p></div>
            <div class="sewage-detail detail">
              <!-- <div class="detail-item"><span class="red-circle"></span><p style="font-size: 0.9vw;color: #ff0000">PM2.5超标，数值86μg/m³</p></div> -->
              <div class="detail-item"><p style="font-size: 0.9vw;">暂无预警</p></div>
            </div>
            <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">设备状态</p></div>
            <div class="sewage-table">
              <div>暂无设备</div>
              <!-- <div class="sewage-table-tr">
                <p>设备1</p>
                <p>开启</p>
                <p>设备正常</p>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 污水监测结束 -->
      <!-- 能耗监测开始 -->
      <div class="energy">
        <div class="title">能耗监测</div>
        <div class="energy-content">
          <div class="energy-left">
            <div style="display: flex;align-items: center;">
              <span class="circle"></span><p style="font-size: 1.1vw">周数据</p>
              <div style="width:15vw;height:3vh;border:1px solid #ddd;display: flex;align-items: center;padding:0 0.5vw;margin-left: 5vw;">
                <div style="width:2.5vw;height:100%;display: flex;align-items: center;cursor: pointer;" @click="preWeek"><i class="el-icon-arrow-left"></i></div>
                <p style="flex:1;">
                  <span class="nowrap" :title="weekStart + ' ~ ' + weekEnd" style="display: inline-block;width:100%;">{{weekStart + ' ~ ' +weekEnd}}</span>
                </p>
                  <div style="width:2.5vw;height:100%;display: flex;align-items: center;cursor: pointer;" @click="nextWeek"><i class="el-icon-arrow-right"></i></div>
              </div>
            </div>
            <div ref="chart4" style="width: 95%;height: calc(100% - 4vh);"></div>
          </div>
          <div class="energy-center">
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">月数据</p></div>
              <p style="color: #598AF3;">{{ new Date().getMonth() + 1 }}月用水/电</p>
            </div>
            <div ref="chart5" style="width: 95%;height: calc(100% - 4vh);"></div>
          </div>
          <div class="energy-right">
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">年度统计</p></div>
              <p style="color: #598AF3;">{{ new Date().getFullYear() }}年度用水/电占比</p>
            </div>
             <div ref="chart6" style="width: 95%;height: calc(100% - 4vh);"></div>
             <div style="position: absolute;top: 10vh;right: 10px;">
               <div>
                 <img style="width: 40px;height: 40px;" src="../../assets/image/elecChart.png">
                 <p style="font-size: 0.6vw;">用电占比</p>
               </div>
               <div style="margin-top: 3vh;">
                 <img style="width: 40px;height: 40px;" src="../../assets/image/waterChart.png">
                 <p style="font-size: 0.6vw;">用水占比</p>
               </div>
             </div>
          </div>
        </div>
      </div>
      <!-- 能耗监测结束 -->
      <!-- 喷淋联动开始 -->
      <div class="ganged">
         <div class="title">喷淋联动</div>
         <div class="ganged-content">
           <div class="ganged-left">
             <div style="display: flex;justify-content: space-between;">
                <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">雾炮、喷淋、照明系统 </p></div>
                 <div style="width:15vw;height:3vh;border:1px solid #ddd;display: flex;align-items: center;padding:0 0.5vw;margin-left: 5vw;">
                  <div style="width:2.5vw;height:100%;display: flex;align-items: center;cursor: pointer;" @click="preWeek2"><i class="el-icon-arrow-left"></i></div>
                  <p style="flex:1;">
                    <span class="nowrap" :title="weekStart2 + ' ~ ' + weekEnd2" style="display: inline-block;width:100%;">{{weekStart2 + ' ~ ' +weekEnd2}}</span>
                  </p>
                    <div style="width:2.5vw;height:100%;display: flex;align-items: center;cursor: pointer;" @click="nextWeek2"><i class="el-icon-arrow-right"></i></div>
                </div>
                <div style="color: #598AF3;">{{new Date().getMonth() + 1}}月开启次数</div>
             </div>
             <div ref="chart7" style="width: 100%;height: calc(100% - 3vh);"></div>
           </div>
           <div class="ganged-right">
            <div style="display: flex;justify-content: space-between;">
                <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">雾炮、喷淋、照明系统 </p></div>
                <div style="color: #598AF3;">{{new Date().getMonth() + 1}}月开启时间</div>
             </div>
            <div ref="chart8" style="width: 100%;height: calc(100% - 3vh);"></div>
           </div>
         </div>
      </div>
      <!-- 喷淋联动结束 -->
      <!-- 建筑垃圾开始 -->
       <div class="sewage">
        <div class="title">建筑垃圾</div>
        <div class="sewage-content">
          <div class="sewage-left">
             <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">周数据</p></div>
             <div ref="chart9" style="width: 94%;height: calc(100% - 4vh);"></div>
          </div>
          <div class="sewage-center">
            <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">年度数据</p></div>
            <div ref="chart10" style="width: 90%;height: calc(100% - 4vh);"></div>
          </div>
          <div class="sewage-right">
            <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">超限预警</p></div>
            <div class="sewage-detail detail" style="height: calc(100% - 4vh);">
              <!-- <div class="detail-item"><span class="red-circle"></span><p style="font-size: 0.9vw;color: #ff0000">PM2.5超标，数值86μg/m³</p></div> -->
              <div class="detail-item"><p style="font-size: 0.9vw;">暂无预警</p></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 建筑垃圾结束 -->
    </div>
  </div>
</template>

<script>
  import util from '../../untils/util'
  import myHttp from '../../untils/port'
  import base from '../../untils/base'
  export default {
    data() {
      return {
        dustId: '',  // 第一个扬尘设备的id
        weekStart: '',
        weekEnd: '',
        weekStart2: '',
        weekEnd2: '',
        groupId: '',
        time: util.myTime.formatTime(new Date(),'yyyy-MM-dd'),  //扬尘天气时间
        weather:{    //天气信息
          now1:require('../../assets/image/weather/w0.png'),
          now2:'7° ~ 16°',
          now3:'晴天',
        },
        newValData: [],   //
        normalDate: {     // 正常数据，
            pm2Switch: 1,
            pm2: '',
            pm10Switch: 1,
            pm10: '',
            tsp: '',
            temperatureSwitch: 1,
            temperature: '',
            humiditySwitch: 1,
            humidity: '',
            noiseSwitch: 1,
            noise: '',
            windSpeedSwitch: 1,
            windSpeed: '',
        },   
        energyWeek: [],    // 能耗监测 周
        waterData: [],   //  水数据
        electricityData: [],   // 电数据
        energyMonth: [],  //能耗监测月数据
        waterMonthData: [],   //  水数据  月
        electricityMonthData: [],   // 电数据  月
        waterYearData: [],   //  水数据   年
        electricityYearData: [],   // 电数据  年
        earlyWarnData: [],   // 预警数据
        earlyWarnDataDetail: [],    // 预警具体数据
        week: [],   // 喷淋、雾炮、照明
        count1: [],   // 雾炮
        count2: [],   // 喷淋
        count3: [],    // 照明
        value1: 0,   // 照明
        value2: 0,    //  喷淋
        value3: 0,    //  雾炮
      }
    },
    mounted(){
      const curWeek = util.myTime.getCurWeek()
      this.weekStart = curWeek[0]
      this.weekEnd = curWeek[1]
      this.weekStart2 = curWeek[0]
      this.weekEnd2 = curWeek[1]
       if (util.session.get('roleId') != '4') {
          this.groupId = util.session.get('proId')
        } else {
          this.groupId = util.session.get('groupId')
        }
      this.getList()
      this.getConfigForWarn()
      this.getEnergyWaterWeek()
      this.getProjectById()
      this.getEnergyWaterMonth()
      this.getEnergyWaterYear()
      this.getOpenCount()
      this.getOpenTimeRatio()


      this.initChart2()
      this.initChart3()
      this.initChart9()
      this.initChart10()
    },
    methods: {
        getWeather(city){
        var that = this;
        city = city?city:'合肥市'
        myHttp.getWeather({
            city:city
        }).then(function(resp){
            if(resp.data.code=='200'){
                var info = resp.data.data.data
                that.weather.now1 = that.getSkyIcon(info.forecast[0].type);
                that.weather.now2 = info.forecast[0].low.split(' ')[1] + '~' + info.forecast[0].high.split(' ')[1];
                that.weather.now3 = info.forecast[0].type;
                that.weather.tomorrow = that.getSkyIcon(info.forecast[1].type);
                that.weather.after1 = that.getSkyIcon(info.forecast[2].type);
                that.weather.after2 = that.getSkyIcon(info.forecast[3].type);
                that.valData[2].val2 = info.forecast[0].fengxiang
            }
        })
      },
      // 获取预警
      getConfigForWarn(){
        myHttp.selectDustConfig({
          projectId:util.session.get('groupId')
        }).then(resp => {
          if(resp.data.code == '200'){
            console.log(resp)
            if(resp.data.data.list){
              this.normalDate = resp.data.data.list
            }
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      // 获取扬尘设备列表
      getList(){
        myHttp.getListByProjectIdList({
          projectId: this.groupId
        }).then(resp => {
          if(resp.data.code == '200'){
            this.dustList = resp.data.data.dustList || []
            this.dustId = this.dustList[0].sn
            // this.$store.commit('changeDustId', this.dustList[0].sn)
            this.getRaiseDustData()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      // 获取扬尘检测数据
      getRaiseDustData() {
        const dustId = util.session.get('dustId') || this.dustId
        let that = this
        myHttp.getCurDustInfo({
          projectId:this.groupId,
          id:dustId
        }).then(function(resp){
          console.log(resp,'999999999999999')
          if(resp.data.code=='200'){
            var data = resp.data.data.dust
            that.newValData = [
              data.pm2?parseFloat(data.pm2):0,
              data.pm10?parseFloat(data.pm10):0,
              data.tspCodedata?parseFloat(data.tspCodedata):0,
              data.temperature?parseFloat(data.temperature):0,
              data.humidity?parseFloat(data.humidity):0,
              data.noise?parseFloat(data.noise):0,
              data.windSpeed?parseFloat(data.windSpeed):0,
              data.pressureCode?parseFloat(data.pressureCode):0
            ]
            /**
             *   if(data.name == 'PM2.5'){
                        if(data.value > that.normalDate.pm2) 
                      if(data.name == 'PM10'){
                        if(data.value > that.normalDate.pm10) 
                      if(data.name == '温度'){
                        if(data.value > that.normalDate.temperature)
                      if(data.name == '湿度'){
                        if(data.value > that.normalDate.humidity)
                      if(data.name == '噪音'){
                        if(data.value > that.normalDate.noise)
                      if(data.name == '风速'){
                        if(data.value > that.normalDate.windSpeed)
            */
          that.earlyWarnData = []
          that.earlyWarnDataDetail = []
            if(Number(data.pm2) > Number(that.normalDate.pm2)){
              that.earlyWarnData.push('PM2.5预警')
              that.earlyWarnDataDetail.push(`PM2.5不正常，数值${data.pm2}μg/m³`)
            }
            if(Number(data.pm10) > Number(that.normalDate.pm10)){
              that.earlyWarnData.push('PM10预警')
              that.earlyWarnDataDetail.push(`PM10不正常，数值${data.pm10}μg/m³`)
            }
            if(Number(data.temperature) > Number(that.normalDate.temperature)){
              that.earlyWarnData.push('温度预警')
              that.earlyWarnDataDetail.push(`温度不正常，数值${data.temperature}°C`)
            }
            if(Number(data.humidity) > Number(that.normalDate.humidity)){
              that.earlyWarnData.push('湿度预警')
              that.earlyWarnDataDetail.push(`湿度不正常，数值${data.humidity}`)
            }
            if(Number(data.noise) > Number((that.normalDate.noise))){
              that.earlyWarnData.push('噪音预警')
              that.earlyWarnDataDetail.push(`噪音不正常，数值${data.noise}`)
            }
            if(Number(data.windSpeed) > Number(that.normalDate.windSpeed)){
              that.earlyWarnData.push('风速预警')
              that.earlyWarnDataDetail.push(`风速不正常，数值${data.windSpeed}`)
            }
          }
          if(that.timeOutFun){
            window.clearTimeout(that.timeOutFun)
          }
          that.timeOutFun = setTimeout(()=>{
            that.getRaiseDustData()
          },180000)
          that.initChart1()
        })
      },
      // 获取能耗监测周数据 --  水  1  水   2  电
      getEnergyWaterWeek(){
        myHttp.selectWaterByChartDay({
          projectId: this.groupId,
          type: 1,
          startDate: this.weekStart,
          endDate: this.weekEnd
        }).then(resp => {
          if(resp.data.code == '200'){
            const list = resp.data.data.data
            for(let i=0;i<list.length;i++){
              this.energyWeek.push(list[i].clickDate)
              this.waterData.push(list[i].count)
            }
            this.getEnergyWeek()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      //  获取能耗监测周数据  -- 电
      getEnergyWeek(){
        myHttp.selectWaterByChartDay({
          projectId: this.groupId,
          type: 2,
          startDate: this.weekStart,
          endDate: this.weekEnd
        }).then(resp => {
          if(resp.data.code == '200'){
            const list = resp.data.data.data
            for(let i=0;i<list.length;i++){
              this.electricityData.push(list[i].count)
            }
            this.initChart4()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      //获取上周时间
      preWeek(){
        this.energyWeek = []
        this.waterData = []
        this.electricityData = []
        const date= util.myTime.getPrevWeek(this.weekStart)
        this.weekStart = date[0]
        this.weekEnd = date[1]
        this.getEnergyWaterWeek()
      },
      preWeek2(){
        const date= util.myTime.getPrevWeek(this.weekStart2)
        this.weekStart2 = date[0]
        this.weekEnd2 = date[1]
        this.getOpenCount()
      },
      //获取下周时间
      nextWeek(){
        this.energyWeek = []
        this.waterData = []
        this.electricityData = []
        const date= util.myTime.getNextWeek(this.weekEnd)
        this.weekStart = date[0]
        this.weekEnd = date[1]
        this.getEnergyWaterWeek()
      },
      nextWeek2(){
        const date= util.myTime.getNextWeek(this.weekEnd2)
        this.weekStart2 = date[0]
        this.weekEnd2 = date[1]
        this.getOpenCount()
      },
      // 获取能耗监测月数据  --  水
      getEnergyWaterMonth(){
        const year = new Date().getFullYear()
        const month = new Date().getMonth() + 1
        let month1 = ''
        if([1,2,3,4,5,6,7,8,9].includes(month)){
          month1 = '0' + month
        }else {
          month1 = month
        }
        myHttp.selectWaterByChartMonth({
          projectId: this.groupId,
          type: 1,
          year: year,
          month: month,
          startDate: year + '-' + month1 + '-01'
        }).then(resp => {
          if(resp.data.code == '200'){
            const list = resp.data.data.data
            for(let i=0;i<list.length;i++){
              if(list[i].clickDate.startsWith(year+'-'+month1)){
                this.energyMonth.push(list[i].clickDate)
                this.waterMonthData.push(list[i].count)
              }
            }
            this.getEnergyMonth()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      // 获取能耗监测月数据  --  电
      getEnergyMonth(){
        const year = new Date().getFullYear()
        const month = new Date().getMonth() + 1
        let month1 = ''
        if([1,2,3,4,5,6,7,8,9].includes(month)){
          month1 = '0' + month
        }else {
          month1 = month
        }
        myHttp.selectWaterByChartMonth({
          projectId: this.groupId,
          type: 2,
          year: year,
          month: month,
          startDate: year + '-' + month1 + '-01'
        }).then(resp => {
          if(resp.data.code == '200'){
            const list = resp.data.data.data
            for(let i=0;i<list.length;i++){
              if(list[i].clickDate.startsWith(year+'-'+month1)){
                this.electricityMonthData.push(list[i].count)
              }
            }
            this.initChart5()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      // 获取能耗监测 年数据  -- 水
      getEnergyWaterYear(){
        myHttp.selectWaterByQuarter({
          projectId: this.groupId,
          type: 1,
          year: new Date().getFullYear()
        }).then(resp => {
          let obj = {}
          if(resp.data.code == '200'){
            const list = resp.data.data.yearWater || []
            for(let i=0;i<list.length;i++){
              obj.name = list[i].quarter
              obj.value = list[i].allCalculateUseOf
              this.waterYearData.push(JSON.parse(JSON.stringify(obj)))
            }
            this.getEnergyYear()
          }else{
            this.$message.error(resp.date.msg)
          }
        })
      },
      // 获取能耗监测 年数据  -- 电
      getEnergyYear(){
        myHttp.selectWaterByQuarter({
          projectId: this.groupId,
          type: 2,
          year: new Date().getFullYear()
        }).then(resp => {
          let obj = {}
          if(resp.data.code == '200'){
            const list = resp.data.data.yearWater || []
            for(let i=0;i<list.length;i++){
              obj.name = list[i].quarter
              obj.value = list[i].allCalculateUseOf
              this.electricityYearData.push(JSON.parse(JSON.stringify(obj)))
            }
            this.initChart6()
          }else{
            this.$message.error(resp.date.msg)
          }
        })
      },
      // 获取雾炮、喷淋、照明开启次数
      getOpenCount(){
        myHttp.getProjectDustCount({
          projectId: this.groupId,
          startTime: this.weekStart2,
          endTime: this.weekEnd2
        }).then(resp => {
          if(resp.data.code === 200){
            const list = resp.data.data.count
            let wupao = [], penlin = [], zhaoming = [], week = []
            list.forEach(item => {
              for(let i in item){
                week.push(i)
                penlin.push(item[i][0])
                wupao.push(item[i][1])
                zhaoming.push(item[i][2])
              }
            })
            this.week = week
            this.count1 = wupao
            this.count2 = penlin
            this.count3 = zhaoming 
            this.initChart7()
          }
        })
      },
      //  获取雾炮、喷淋、照明开启时间比例
      getOpenTimeRatio(){
        myHttp.getProjectDustCountPersent({
          projectId: this.groupId,
          startTime: util.myTime.getCurMonth(),
          endTime: ''
        }).then(resp => {
          if(resp.data.code === 200){
            const data = resp.data.data.count
            this.value1 = data.type3
            this.value2 = data.type1
            this.value3 = data.type2
            this.initChart8()
          }
        })
      },
      getSkyIcon(type){
        if(type=='多云'){
            return require('../../assets/image/weather/w1.png');
        }else if(type=='晴天'){
            return require('../../assets/image/weather/w0.png');
        }else if(type=='阴'){
            return require('../../assets/image/weather/w2.png');
        }else if(type.indexOf("雷阵雨")>-1){
            return require('../../assets/image/weather/w4.png');
        }else if(type.indexOf("阵雨")>-1){
            return require('../../assets/image/weather/w3.png');
        }else if(type.indexOf("雨")>-1){
            return require('../../assets/image/weather/w5.png');
        }else if(type.indexOf("雪")>-1){
            return require('../../assets/image/weather/w6.png');
        }else{
            return require('../../assets/image/weather/w1.png');
        }
      },
      //  扬尘监测    实时数据
      initChart1(){
         let that = this
         let myChart = this.$echarts.init(this.$refs.chart1)
         myChart.setOption({
            xAxis: {
              type: 'value',
            },
            yAxis: {
              type: 'category',
              data: ["PM2.5","PM10","TSP","温度","湿度","噪音","风速","气压"],
              barWidth: 40,
              axisLabel: {
                textStyle: {
                  fontSize: 16,
                },
              },
              axisTick: {
                show: false    //  不显示y轴刻度线
              }
            },
            series: [
              {
                type: 'bar',
                data: this.newValData,
                label: {
                  show: true,
                  position: 'right'
                },
                showBackground: true,   //开启柱形图背景颜色
                itemStyle: {
                   barBorderRadius: [0, 20, 20, 0],   //设置柱形图顶部圆角
                    color: function(data){
                    let color = []
                    if(data.name == 'PM2.5'){
                      if(data.value > that.normalDate.pm2) {
                        color[0] = '#ff0000'
                      }else{
                        color[0] = '#1668f0'
                      }
                    }
                    if(data.name == 'PM10'){
                      if(data.value > that.normalDate.pm10) {
                        color[1] = '#ff0000'
                      }else{
                        color[1] =  '#1668f0'
                      }
                    }   
                    if(data.name == '温度'){
                      if(data.value > that.normalDate.temperature) {
                        color[3] = '#ff0000'
                      }else{
                        color[3] =  '#1668f0'
                      }
                    }
                    if(data.name == '湿度'){
                      if(data.value > that.normalDate.humidity) {
                        color[4] = '#ff0000'
                      }else{
                        color[4] =  '#1668f0'
                      }
                    }
                    if(data.name == '噪音'){
                       if(data.value > that.normalDate.noise) {
                          color[5] = '#ff0000'
                        }else{
                          color[5] =  '#1668f0'
                        }
                    }
                    if(data.name == '风速'){
                      if(data.value > that.normalDate.windSpeed) {
                        color[6] = '#ff0000'
                      }else{
                        color[6] =  '#1668f0'
                      }
                    }
                    color[2] = '#1668f0'
                    color[7] = '#1668f0'
                    return color[data.dataIndex]
                  }
                }
              }
            ],
            grid: {
              left: '8%',
              right: '5%'
            }
         })
         window.addEventListener("resize", () => {
          myChart.resize();
        });
      },
      //   污水监测   实时数据
      initChart2(){
        let myChart = this.$echarts.init(this.$refs.chart2)
        myChart.setOption({
          xAxis: {
            data: ["PH","NTU","COD","BOD","磷","硫化物"],
            axisTick: {
              show: false      // 不显示刻度线
            }
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              type: 'bar',
              data: [0,0,0,0,0,0],
              barWidth: 20,
              label: {
                show: true,
                position: 'top'
              },
              itemStyle: {
                normal: {
                  color: function(data){
                    if(data.value >= 50) {
                      return 'red'
                    }else{
                      return '#80b8e6'
                    }
                  }
                }
              }
            }
          ]
        })
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      },
      //  污水监测  周数据
      initChart3(){
        let myChart = this.$echarts.init(this.$refs.chart3)
        myChart.setOption({ 
          title: {
            text: '一周数据占比',
            top: '45%',
            left: 'center'
          },
          series: [
            {
              type: 'pie',
              radius: ['50%', '70%'],
              data: [
                {
                  name: 'PH',
                  value: 0
                },
                {
                  name: 'NTU',
                  value: 0
                },
                {
                  name: 'COD',
                  value: 0
                },
                 {
                  name: 'BOD',
                  value: 0
                },
                 {
                  name: '磷',
                  value: 0
                },
                 {
                  name: '硫化物',
                  value: 0
                }
              ],
              label: {
                formatter: '{b}\n{d}%'
              },
              labelLine: {
                normal: {
                  show: true
                }
              },
            }
          ]
        })
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      },
      // 能耗监测   周数据
      initChart4(){
        let myChart = this.$echarts.init(this.$refs.chart4)
        myChart.setOption({
          legend: {
            orient: 'vertical',
            right: 10,
            top: 0,
          },
          xAxis: [
            {
              type: 'category',
              data: this.energyWeek,
              axisTick: {
                show: false      // 不显示刻度线
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
            },
            {
              type: 'value',
            }
          ],
          series: [
            {
              name: '用水量',
              type: 'bar',
              yAxisIndex: 0,
              color: '#80b8e6',
              data: this.waterData,
              barWidth: 20,
              label: {
                normal: {
                  show: true,
                  position: 'top'
                }
              }
            },
            {
              name: '用电量',
              type: 'bar',
              yAxisIndex: 1,
              color: '#0b62f0',
              data: this.electricityData,
              barWidth: 20,
              label: {
                normal: {
                  show: true,
                  position: 'top'
                }
              }
            }
          ]
        })
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      },
      // 能耗监测  月数据
      initChart5(){
        let myChart5 = this.$echarts.init(this.$refs.chart5)
        myChart5.setOption({
          legend: {

          },
          xAxis: [
            {
              type: 'category',
              data: this.energyMonth,
              axisTick: {
                show: false      // 不显示刻度线
              },
              boundaryGap: false,    // x轴两边不留空白
            }
          ],
          yAxis: [
            {
              type: 'value',
            },
            {
              type: 'value',
            }
          ],
          series: [
            {
              name: '月用水量',
              type: 'line',
              yAxisIndex: 0,
              color: '#80b8e6',
              data: this.waterMonthData,
              barWidth: 20,
              areaStyle: {},
              // label: {
              //   normal: {
              //     show: true,
              //     position: 'outside'
              //   }
              // }
            },
            {
              name: '月用电量',
              type: 'line',
              yAxisIndex: 1,
              color: '#0b62f0',
              data: this.electricityMonthData,
              barWidth: 20,
              areaStyle: {},
              // label: {
              //   normal: {
              //     show: true,
              //     position: 'outside'
              //   }
              // }
            }
          ]
        })
         window.addEventListener("resize", () => {
          myChart5.resize();
        });
      },
      // 能耗监测  --  年度统计
      initChart6(){
        let myChart6 = this.$echarts.init(this.$refs.chart6)
        myChart6.setOption({
          // legend: {

          // },
          series: [
            {
              type: 'pie',
              name: '用电占比',
              radius: [0, '55%'],
              color: ['#9AC1FF', '#3582FF', '#0263FF', '#67A1FF'],
              label: {
                formatter: '{b}\n{d}%',
                position: 'inner',
              },
              labelLine: {
                show: false
              },
              data: this.electricityYearData
            },
            {
              type: 'pie',
              name: '用水占比',
              radius: ['65%', '85%'],
              color: ['#67A1FF', '#0263FF', '#5582CA', '#9AC1FF'],
              label: {
                formatter: '{b}\n{d}%'
              },
              data: this.waterYearData
            }
          ]
        })
        window.addEventListener("resize", () => {
          myChart6.resize();
        });
      },
      // 喷淋联动   折线图
      initChart7(){
        let myChart = this.$echarts.init(this.$refs.chart7)
        myChart.setOption({
          legend: {
           top: '30',
           right: 'right'
          },
          grid: {
            left: 30
          },
          xAxis: {
            type: 'category',
            data: this.week,
            boundaryGap: false,    // x轴两边不留空白
            axisTick: {
              show: false      // 不显示刻度线
            }
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '雾炮',
              type: 'line',
              data: this.count1,
              color: '#80b8e6'
            },
            {
              name: '喷淋',
              type: 'line',
              data: this.count2,
              color: '#0b62f0'
            },
            {
              name: '照明',
              type: 'line',
              data: this.count3,
              color: '#0e9cff'
            }
          ]
        })
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      },
      // 喷淋联动   饼图
      initChart8(){
        let myChart = this.$echarts.init(this.$refs.chart8)
        myChart.setOption({
          title: {
            text: '开启时间统计',
            top: '45%',
            left: 'center'
          },
          series: [
            {
              type: 'pie',
              radius: ['50%', '70%'],
              color: ['#046AFF','#4F86CF','#5FA2FF'],
              label: {
                formatter: `{b}\n{d}%`
              },
              data: [
                {
                  name: '照明',
                  value: this.value1
                },
                {
                  name: '喷淋',
                  value: this.value2
                },
                {
                  name: '雾炮',
                  value: this.value3
                }
              ]
            }
          ]
        })
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      },
      //   建筑垃圾  周数据
      initChart9(){
        let myChart = this.$echarts.init(this.$refs.chart9)
        myChart.setOption({
          grid: {
            left: 40,
            bottom: 20            
          },
          legend: {
            orient: 'vertical',
            top: 50,
            right: 0
          },
          xAxis: {
            type: 'category',
            data: ['周一','周二','周三','周四','周五','周六','周日'],
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'A站点',
              type: 'bar',
              data: [0,0,0,0,0,0,0],
              color: '#0b62f0',
              barWidth: 15,
              label: {
                normal: {
                  show: true,
                  position: 'top'
                }
              }
            },
            {
              name: 'B站点',
              type: 'bar',
              data: [0,0,0,0,0,0,0],
              color: '#80b8e6',
              barWidth: 15,
              label: {
                normal: {
                  show: true,
                  position: 'top'
                }
              }
            }
          ]
        })
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      },
      // 建筑垃圾   年度统计
      initChart10(){
        let myChart = this.$echarts.init(this.$refs.chart10)
        myChart.setOption({
          title: {
            text: '建筑垃圾堆放总量',
            top: '45%',
            left: 'center'
          },
          series: [
            {
              type: 'pie',
              radius: ['50%', '70%'],
              color: ['#046AFF','#4F86CF','#5FA2FF','#8DBFFF'],
              data: [
                {
                  name: '第一季度',
                  value: 0
                },
                {
                  name: '第二季度',
                  value: 0
                },
                {
                  name: '第三季度',
                  value: 0
                },
                {
                  name: '第四季度',
                  value: 0
                }
              ],
              label: {
                formatter: '{b}\n{d}%'
              },
            }
          ]
        })
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      },
      /**
       * 获取天气
       */
      getProjectById(){
          var that = this
          myHttp.getProjectById({
              id: this.groupId
          }).then(function(resp) {
              if (resp.data.code == '200') {
                  var data = resp.data.data.project
                  that.setAreaFun(data.areaId)
              }
          })
      },
      //获取省市区
      setAreaFun(id){
        if ('' == id || undefined == id) {
            this.getWeather()
            return
        }
        var that = this
        myHttp.getAreaById({
            id: id
        }).then(function(resp) {
            var proCity = ''
            if (resp.data.code == '200') {
                var city = resp.data.data.area.cityName
                var area = resp.data.data.area.name
                proCity = city.indexOf('市')>0?city:area
                
            }
            that.getWeather(proCity)
        },function(error) {})
      },
      //获取天气
      getWeather(city){
        var that = this;
        city = city?city:'合肥市'
        myHttp.getWeather({
            city:city
        }).then(function(resp){
            if(resp.data.code=='200'){
                var info = resp.data.data.data
                that.weather.now1 = that.getSkyIcon(info.forecast[0].type);
                that.weather.now2 = info.forecast[0].low.split(' ')[1] + '~' + info.forecast[0].high.split(' ')[1];
                that.weather.now3 = info.forecast[0].type;
                that.weather.tomorrow = that.getSkyIcon(info.forecast[1].type);
                that.weather.after1 = that.getSkyIcon(info.forecast[2].type);
                that.weather.after2 = that.getSkyIcon(info.forecast[3].type);
            }
        })
      },
      getSkyIcon(type){
          if(type=='多云'){
              return require('../../assets/image/weather/w1.png');
          }else if(type=='晴天'){
              return require('../../assets/image/weather/w0.png');
          }else if(type=='阴'){
              return require('../../assets/image/weather/w2.png');
          }else if(type.indexOf("雷阵雨")>-1){
              return require('../../assets/image/weather/w4.png');
          }else if(type.indexOf("阵雨")>-1){
              return require('../../assets/image/weather/w3.png');
          }else if(type.indexOf("雨")>-1){
              return require('../../assets/image/weather/w5.png');
          }else if(type.indexOf("雪")>-1){
              return require('../../assets/image/weather/w6.png');
          }else{
              return require('../../assets/image/weather/w1.png');
          }
        },
    },
  }
</script>

<style scoped>
.content{
  height: 100%;
  width: 100%;
  overflow: auto;
}
.grid-content1 {
  font-size: 1.6vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 4px;
}
.alarm{
  width: 100%;
	height: 6vh;
	background-image: linear-gradient(90deg,#f5f5f5 0%, 	#ffffff 64%, #f5f5f5 100%);
	box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.35);
	border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.red-circle{
  display: block;
  width: 0.7vw;
	height: 0.7vw;
  border-radius: 10px;
	background-color: #ff0000;
  margin-right: 0.7vw;
}
.title{
  margin: 1.5vh 0;
  text-align: left;
  color: #333;
}
.dust-content{
  display: flex;
  justify-content: space-between;
}
.dust-left{
  position: relative;
  width: 27%;
  padding: 1vh 1vw;
  background-color: #ffffff;
	box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.35);
	border-radius: 6px;
}
.weather-date{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.weather{
  width: 100%;
  height: 25vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.temperature{
  padding: 0 1vw;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.circle{
  display: block;
  width: 1.5vh;
  height: 1.5vh;
  border-radius: 50%;
  background-color: #0B62F0;
  margin-right: 1vw;
}
.dust-center{
  position: relative;
  padding: 1vh 1vw;
  width: 45%;
  background-color: #ffffff;
	box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.35);
	border-radius: 6px;
}
.dust-right{
  position: relative;
  padding: 1vh 1vw;
  width: 27%;
  background-color: #ffffff;
	box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.35);
	border-radius: 6px;
}
.detail{
  height: 27vh;
  overflow: auto;
  padding: 1vh 0;
}
.detail-item{
  display: flex;
  align-items: center;
  margin-bottom: 1vh;
}
.sewage{
  height: 40vh;
}
.sewage-content{
  display: flex;
  height: 100%;
  justify-content: space-between;
}
.sewage-left{
  position: relative;
  width: 42%;
  height: calc(100% - 4vh);
  padding: 1vh 1vw;
  background-color: #ffffff;
	box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.35);
	border-radius: 6px;
}
.sewage-center{
  position: relative;
  width: 30%;
  height: calc(100% - 4vh);
  padding: 1vh 1vw;
  background-color: #ffffff;
	box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.35);
	border-radius: 6px;
}
.sewage-right{
  position: relative;
  width: 27%;
  height: calc(100% - 4vh);
  padding: 1vh 1vw;
  background-color: #ffffff;
	box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.35);
	border-radius: 6px;
}
.sewage-detail{
  height: 12vh;
  overflow: auto;
}
.sewage-table{
  height: 15vh;
  overflow: auto;
}
.sewage-table-tr{
  display: flex;
  padding-right: 3vw;
  margin: 1vh 0;
  justify-content: space-around;
}
.energy{
  height: 40vh;
}
.energy-content{
  display: flex;
  height: 100%;
  justify-content: space-between;
}
.energy-left{
  position: relative;
  width: 42%;
  height: calc(100% - 4vh);
  padding: 1vh 1vw;
  background-color: #ffffff;
	box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.35);
	border-radius: 6px;
}
.energy-center{
  position: relative;
  width: 30%;
  height: calc(100% - 4vh);
  padding: 1vh 1vw;
  background-color: #ffffff;
	box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.35);
	border-radius: 6px;
}
.energy-right{
  position: relative;
  width: 27%;
  height: calc(100% - 4vh);
  padding: 1vh 1vw;
  background-color: #ffffff;
	box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.35);
	border-radius: 6px;
}
.ganged-content{
  display: flex;
  height: 100%;
  justify-content: space-between;
}
.ganged{
  height: 42vh;
}
.ganged-left{
  position: relative;
  width: 62%;
  height: calc(100% - 4vh);
  padding: 1vh 1vw;
  background-color: #ffffff;
	box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.35);
	border-radius: 6px;
}
.ganged-right{
  position: relative;
  width: 37.5%;
  height: calc(100% - 4vh);
  padding: 1vh 1vw;
  background-color: #ffffff;
	box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.35);
	border-radius: 6px;
}
</style>